import { type TAdFoxBannerTemplate } from '@cian/adfox-component';
import { AdFoxTemplates } from '@cian/adfox-templates';

import { Base64 } from 'js-base64';
import { type FC } from 'react';

import { useApplicationContext } from '@/app/shared/context/ApplicationContext';

import { useAdfoxContext } from '@/packages/adfox/AdfoxContext';
import { type TgbNativedescGeneralContext } from '@/packages/adfox/types/tgb-native-banner';

import { TgbNativedescGeneralContainer } from './internal/components/TgbNativedescGeneral';

const OWN_BUNDLE_NAMES = ['banner.transfer'];

const HTML_BUNDLE_NAMES = ['banner.interscroller', 'banner.html'];

export type AdFoxTemplateParams = TgbNativedescGeneralContext;

export const OwnTemplates: FC<TAdFoxBannerTemplate> = props => {
  const { bundleName, bundleParams } = props;

  const { logger } = useApplicationContext();
  const { bannerDeviceType, trackBannerAsHtml } = useAdfoxContext();

  if (bundleName && OWN_BUNDLE_NAMES.includes(bundleName) && bundleParams) {
    if (bundleName === 'banner.transfer' && bundleParams.htmlBase64) {
      try {
        const decodedParams = Base64.decode(bundleParams.htmlBase64);
        const parsedDecodedParams = JSON.parse(decodedParams);

        if (isParsedParamsValid(parsedDecodedParams)) {
          switch (parsedDecodedParams.type) {
            case 'tgb_nativedesc_general':
              return <TgbNativedescGeneralContainer context={parsedDecodedParams} />;
          }
        }
      } catch (e) {
        logger.error(e as Error, {
          bannerId: props.bundleParams?.bannerId,
          message: '[AdFox] Failed to decode/parse bundleParams',
        });
      }
    }
  }

  /**
   * @description
   * Помечаем баннер как HTML.
   * Это нужно для перерисовке конкретных баннеров при изменении viewMode
   */
  if (bundleName && HTML_BUNDLE_NAMES.includes(bundleName) && trackBannerAsHtml) {
    trackBannerAsHtml();
  }

  return <AdFoxTemplates {...props} deviceType={bannerDeviceType} />;
};

function isParsedParamsValid(params: object): params is AdFoxTemplateParams {
  return 'type' in params;
}
